import { css } from '@styled-system/css';

// Squelette de card de plan — mêmes proportions que SubscriptionPlanCard
// (card élevée 2xl, badge d'icône, prix, CTA, lignes de features).

const card = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  gap: '6',
  minHeight: '440px',
  padding: { base: '7', md: '8' },
  borderRadius: '2xl',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'border.subtle',
  bg: 'surface.elevated',
  boxShadow: 'sm',
  animation: 'skeletonPulse 1.6s ease-in-out infinite',
});

const bar = css({ borderRadius: 'full', bg: 'surface.sunken' });

export const SubscriptionPlanCardSkeleton = () => (
  <div className={card}>
    <div className={css({ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '3' })}>
      <div className={css({ width: '52px', height: '52px', borderRadius: 'xl', bg: 'surface.sunken' })} />
      <div className={bar} style={{ width: '45%', height: 16 }} />
    </div>
    <div className={bar} style={{ width: '60%', height: 28 }} />
    <div className={bar} style={{ width: '100%', height: 42, borderRadius: 12 }} />
    <div className={css({ height: '1px', bg: 'border.subtle' })} />
    <div className={css({ display: 'flex', flexDirection: 'column', gap: '5', flex: 1 })}>
      {[0, 1, 2, 3].map((i) => (
        <div key={i} className={css({ display: 'flex', alignItems: 'center', gap: '3' })}>
          <div className={css({ width: '30px', height: '30px', borderRadius: 'lg', bg: 'surface.sunken' })} />
          <div className={bar} style={{ width: `${70 - i * 8}%`, height: 11 }} />
        </div>
      ))}
    </div>
  </div>
);
